module.exports = __webpack_public_path__ + "static/media/momounderground.ca04da61.jpg";